import { makeStyles } from '@/styles/theme/tss-react';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
  hideImageOnMobile: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'SubmitStep',
})(
  (
    { brandColors, spacing, breakpoints, type, aspectRatio, typography },
    props
  ) => ({
    inputGroup: {
      margin: `${spacing(2)} 0`,
    },
    inputContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      '&:first-child': {
        marginBottom: spacing(1),
      },
      [breakpoints.up('sm')]: {
        width: typography.pxToRem(390),
      },
      [breakpoints.up('md')]: {
        marginBottom: spacing(2),
        width: typography.pxToRem(328),
      },
      [breakpoints.up('lg')]: {
        width: '42.5rem',
        flexDirection: 'row',
      },
    },
    input: {
      width: '100%',
      '&:not(:last-child)': {
        marginBottom: spacing(1),
      },
      [breakpoints.up('sm')]: {
        marginRight: spacing(2),
        '&:not(:last-child)': {
          marginBottom: spacing(2),
        },
      },
      [breakpoints.up('lg')]: {
        marginRight: spacing(2),
        '&:not(:last-child)': {
          marginBottom: 0,
        },
      },
    },
    landerImage: {
      borderRadius: typography.pxToRem(16),
      width: '100%',
      objectFit: 'cover',
      aspectRatio: aspectRatio['4/3'],
      height: 'auto',
    },
    button: {
      minWidth: typography.pxToRem(142),
      padding: `${typography.pxToRem(18)} ${spacing(1)}`,
      marginBottom: spacing(3),
      [breakpoints.up('lg')]: {
        margin: 0,
      },
    },
    heading: {
      maxWidth: typography.pxToRem(390),
      color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
      [breakpoints.up('sm')]: {
        maxWidth: typography.pxToRem(539),
      },
      [breakpoints.up('lg')]: {
        maxWidth: typography.pxToRem(627),
      },
      [breakpoints.up('xl')]: {
        maxWidth: typography.pxToRem(840),
      },
    },
    subheading: {
      margin: `${spacing(1)} 0 ${spacing(2)} 0`,
      color: darkOrLightStyle(props)(
        brandColors.tintsOffWhite40,
        brandColors.tintsNeutral20
      ),
      maxWidth: typography.pxToRem(390),
      [breakpoints.up('md')]: {
        maxWidth: typography.pxToRem(539),
      },
      [breakpoints.up('lg')]: {
        maxWidth: typography.pxToRem(627),
      },
      [breakpoints.up('xl')]: {
        maxWidth: typography.pxToRem(840),
      },
    },
    tcpa: {
      '& p': {
        color: darkOrLightStyle(props)(
          brandColors.tintsOffWhite40,
          brandColors.tintsNeutral20
        ),
        '& a': {
          color: darkOrLightStyle(props)(
            `${brandColors.tintsOffWhite40}!important`,
            `${brandColors.tintsNeutral20}!important`
          ),
        },
        fontSize: `${type['12_regular'].fontSize}!important`,
        fontWeight: `${type['12_regular'].fontWeight}!important`,
        lineHeight: `${type['12_regular'].lineHeight}!important`,
        letterSpacing: `${type['12_regular'].letterSpacing}!important`,
        marginBottom: spacing(2),
      },
      [breakpoints.up('sm')]: {
        '& p': {
          fontSize: `${type['14_regular'].fontSize}!important`,
          fontWeight: `${type['14_regular'].fontWeight}!important`,
          lineHeight: `${type['14_regular'].lineHeight}!important`,
          letterSpacing: `${type['14_regular'].letterSpacing}!important`,
        },
      },
      [breakpoints.up('lg')]: {
        '& p': {
          fontSize: `${type['16_regular'].fontSize}!important`,
          fontWeight: `${type['16_regular'].fontWeight}!important`,
          lineHeight: `${type['16_regular'].lineHeight}!important`,
          letterSpacing: `${type['16_regular'].letterSpacing}!important`,
        },
      },
    },
    visible: {
      display: 'flex',
    },
    layout: {
      flexDirection: 'column',
      [breakpoints.up('md')]: {
        flexDirection: 'row',
      },
    },
    reverseLayout: {
      flexDirection: 'column-reverse',
      [breakpoints.up('md')]: {
        flexDirection: 'row-reverse',
      },
    },
    hidden: {
      display: 'none',
    },
    step: {
      padding: `${spacing(0)} 0 ${spacing(-1)} 0`,
      textTransform: 'uppercase',
      color: darkOrLightStyle(props)(
        brandColors.tintsOffWhite40,
        brandColors.tintsNeutral20
      ),
    },
    reverseContent: {
      [breakpoints.up('md')]: {
        paddingLeft: spacing(3),
      },
    },
    hideImageOnMobile: {
      [breakpoints.down('md')]: {
        display: props.hideImageOnMobile ? 'none' : 'flex',
      },
    },
  })
);

export default useStyles;
